export default "__VITE_ASSET__DzeXgTSu__"